import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-single-announcement',
  templateUrl: './sample-single-announcement.component.html',
  styleUrls: ['./sample-single-announcement.component.scss']
})
export class SampleSingleAnnouncementComponent implements OnInit {

  @Input() block: any;
  @Input() column: any;
  @Input() padding: boolean = false;
  public classColumn: string = '';
  public domainWebsite = environment.urlApi;

  constructor(
    public nodeService: NodeService,
    public navigationService: NavigationService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.setColumnItem();
  }

  public retriveField(data: string): any {
    const retriveItem = data.match(/\/(it|en|es|fr)(.*)/);
    return retriveItem ? retriveItem[0] : '';
  }

  getDate(item: string): any {
    if (item) {
      const date =  this.datePipe.transform(this.nodeService.retrieveDateTime(item, 'datetime'), 'dd/MM/yyyy');
      const time = this.datePipe.transform(this.nodeService.retrieveDateTime(item, 'datetime'), 'HH:mm');
      return { date, time };      
    } else {
      return { date: '', time: '' };
    }
 }

  private setColumnItem() {
    switch (this.column) {
      case '2':
        if (this.block.length === 1) {
          this.classColumn = 'col-12';
        } else {
          this.classColumn = 'col-12 col-sm-6';
        }
        break;
      case '3':
        if (this.block.length === 1) {
          this.classColumn = 'col-12';
        }
        if (this.block.length === 2) {
          this.classColumn = 'col-12 col-sm-6';
        }
        if (this.block.length > 2) {
          this.classColumn = 'col-12 col-sm-6 col-md-4';
        }
        break;
      case '4':
        if (this.block.length === 1) {
          this.classColumn = 'col-12';
        }
        if (this.block.length === 2) {
          this.classColumn = 'col-12 col-sm-6';
        }
        if (this.block.length === 3) {
          this.classColumn = 'col-12 col-sm-6 col-md-4';
        }
        if (this.block.length > 3) {
          this.classColumn = 'col-12 col-sm-6 col-md-4 col-lg-3';
        }
        break;
      default:
        this.classColumn = 'col-12';
        break;
    }
    if (this.padding) {
      this.classColumn = this.classColumn + ' p-3'
    }
  }
}
